import request, { gql } from "graphql-request";
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Legend, Tooltip, Cell } from "recharts";
import BASEURL from "../../Utils/Baseurl";
import PieChartSkeleton from "./RoundChartSkelton";

const data01 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 300 },
  { name: "Group C", value: 300 },
  { name: "Group D", value: 200 },
  { name: "Group E", value: 278 },
  { name: "Group F", value: 189 },
];
const allUsersWithTotalAmount = gql`
  query {
    allUsersWithTotalAmount {
      username
      percentageOfTotal
    }
  }
`;
const Roundchart = () => {
  const [pieData, setPieData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    request(BASEURL, allUsersWithTotalAmount)
      .then((res) => setPieData(res.allUsersWithTotalAmount))
      .finally(() => setLoading(false));
  }, []);
  const updatedPieData = pieData.map((entry) => ({
    name: entry.username,
    percentageOfTotal:
      entry.percentageOfTotal === 0 ? 0 : Math.round(entry.percentageOfTotal),
  }));

  const COLORS = ["#FF6384", "#36A2EB", "#FFCE56", "#9f5be3"];
  const renderContent = () => {
    if (loading) return <PieChartSkeleton />;
    if (error)
      return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;
    if (updatedPieData.length === 0)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            margin: "10px 0px",
          }}
        >
          <p>No Scheduled Appointment</p>
        </div>
      );

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "10px 0px",
        }}
      >
        <PieChart width={500} height={400}>
          <Pie
            dataKey="percentageOfTotal"
            isAnimationActive={true}
            data={updatedPieData}
            cx={200}
            cy={200}
            outerRadius={140}
            // fill="#8884d8"
            // label
          >
            {updatedPieData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip itemStyle={{color:'green',textTransform:'capitalize'}}/>
          <Legend />
        </PieChart>
      </div>
    );
  };

  return <div>{renderContent()}</div>;
};

export default Roundchart;
